/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDirectionsCarIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-directions-car"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.05 19.35L6.05 19.63Q6.05 20.35 5.55 20.85Q5.05 21.35 4.33 21.35Q3.6 21.35 3.1 20.85Q2.6 20.35 2.6 19.63L2.6 12.4Q2.6 12.18 2.64 11.95Q2.67 11.72 2.75 11.53L4.58 6.42Q4.85 5.63 5.53 5.14Q6.2 4.65 7.05 4.65L16.95 4.65Q17.8 4.65 18.48 5.14Q19.15 5.63 19.43 6.42L21.25 11.53Q21.32 11.72 21.36 11.95Q21.4 12.18 21.4 12.4L21.4 19.63Q21.4 20.35 20.9 20.85Q20.4 21.35 19.68 21.35Q18.95 21.35 18.45 20.85Q17.95 20.35 17.95 19.63L17.95 19.35ZM5.75 9.7L18.25 9.7L17.25 6.9Q17.25 6.9 17.25 6.9Q17.25 6.9 17.25 6.9L6.75 6.9Q6.75 6.9 6.75 6.9Q6.75 6.9 6.75 6.9ZM7.45 16.1Q8.1 16.1 8.57 15.63Q9.05 15.15 9.05 14.5Q9.05 13.85 8.57 13.38Q8.1 12.9 7.45 12.9Q6.8 12.9 6.33 13.38Q5.85 13.85 5.85 14.5Q5.85 15.15 6.33 15.63Q6.8 16.1 7.45 16.1ZM16.55 16.1Q17.2 16.1 17.68 15.63Q18.15 15.15 18.15 14.5Q18.15 13.85 17.68 13.38Q17.2 12.9 16.55 12.9Q15.9 12.9 15.43 13.38Q14.95 13.85 14.95 14.5Q14.95 15.15 15.43 15.63Q15.9 16.1 16.55 16.1Z" fill={color} />
    </svg>
  );
}
